import {Location} from "@angular/common";
import {Injectable, Inject} from "@angular/core";
import {IEnvironment, IFeatureHash, AWSCognitoConfig} from "../../../environments/ienvironment";

@Injectable()
export class DacConfig {
    private _api_url:string;
    private _is_dev_environment:Boolean = false;
    private window: Window;
    private _take_test_url:string;
    private _enabledFeatures:IFeatureHash;
    private _stripePublicKey:String;
    private _stripeChargeName:String;
    private _applicationTitle:string;
    private _applicationLogoUrl:string;
    private _applicationLogoTitle:string;
    private _useAddoReports:boolean;
    private _supportEmail:string;
    private _supportPhone:string;
    private _reportHeaderImgURL:string;
    private _ssoIssuer:string;
    private _skinClasses:string[];
    private _cognitoConfig:AWSCognitoConfig;

    /**
     * When the application is embedded inside another app such as in an iframe we want
     * to hide the components such as navigation so it looks seamless.
     */
    private _seamlessMode:boolean;

    constructor(
        @Inject("Environment") private _environment:IEnvironment
    ) {
        this._enabledFeatures = this._environment.features;
        this._stripePublicKey = this._environment.stripePublicKey;
        this._stripeChargeName = this._environment.stripeChargeName;
        this._applicationTitle = this._environment.applicationTitle;
        this._applicationLogoUrl = this._environment.applicationLogo;
        this._applicationLogoTitle = this._environment.applicationLogoTitle;
        this._api_url = this._environment.apiURL;
        this._supportEmail = this._environment.supportEmail;
        this._supportPhone = this._environment.supportPhone;
        this._reportHeaderImgURL = this._environment.reportHeaderImgURL;
        this._useAddoReports = this._environment.useAddoReports;
        this._cognitoConfig = this._environment.awsCognitoConfig;

        this.window = window as Window;
        let host = this.window.location.host;
        this._take_test_url = this.window.location.protocol + "//" + host + "/login";

        this._skinClasses = this._environment.skinClasses || [];
        this._seamlessMode = sessionStorage.getItem("seamlessMode") === "true";
        if (this._seamlessMode) {
            this.setupSeamlessModeForSession(sessionStorage.getItem('skin'));
        }
        else if (sessionStorage.getItem('skin')) {
            this.setupSkinForSession(sessionStorage.getItem('skin'));
        }
        this._ssoIssuer = sessionStorage.getItem("ssoIssuer");

       
    }

    private getAWSConfig() {
        
    }

    private setupSkinForSession(skin:string) {
        this._skinClasses = skin.split(" ");
    }

    private is_dev_host(host:string) {
        return host === "discoverandchange.dev" || host === "localhost:8080" 
            || host === "localhost:4200"
            || host === 'addo-dev.discoverandchange.com';
    }

    get take_test_url() {
        return this._take_test_url;
    }

    get api_url() : string {
        return this._api_url;
    }

    get is_dev_environment() : Boolean {
        return this._is_dev_environment;
    }

    get stripe_charge_name() : String {
        return this._stripeChargeName;
    }

    get stripe_public_key() : String {
        return this._stripePublicKey;
    }

    public isFeatureEnabled(feature:string) {
        return this._enabledFeatures[feature] === true;
    }


	public get applicationLogoTitle(): string {
		return this._applicationLogoTitle;
	}

	public set applicationLogoTitle(value: string) {
		this._applicationLogoTitle = value;
	}

	public get applicationLogoUrl(): string {
		return this._applicationLogoUrl;
	}

	public set applicationLogoUrl(value: string) {
		this._applicationLogoUrl = value;
	}

	public get applicationTitle(): string {
		return this._applicationTitle;
	}

	public set applicationTitle(value: string) {
		this._applicationTitle = value;
	}

    public get useAddoReports(): boolean {
		return this._useAddoReports;
	}

	public set useAddoReports(value: boolean) {
		this._useAddoReports = value;
    }
    
    public get supportEmail(): string {
		return this._supportEmail;
	}

	public set supportEmail(value: string) {
		this._supportEmail = value;
    }
    

	public get supportPhone(): string {
		return this._supportPhone;
	}

	public set supportPhone(value: string) {
		this._supportPhone = value;
    }
    
    public get skinClasses() : string[] {
        return this._skinClasses;
    }

    public replaceSkinClasses(skinClasses:string[]) {
        if (!skinClasses && skinClasses.length <= 0) {
            throw new Error("Invalid Skin Classes.  Must be an array with length greater than 0");
        }
        this._skinClasses = skinClasses;
        sessionStorage.setItem('skin', skinClasses.join(" "));
    }

    public addSkinClass(skinClass:string) {
        if (skinClass.length <= 0) {
            throw new Error("Skin class must be set ");
        }
        this._skinClasses.push(skinClass);
    }

    public get navBarClass() : string {
        return this._environment.navBarClass;
    }


	public get reportHeaderImgURL(): string {
		return this._reportHeaderImgURL;
	}

	public set reportHeaderImgURL(value: string) {
		this._reportHeaderImgURL = value;
    }
    
    public hasPartner(partner:string) {
        return this._environment.partners.indexOf(partner) >= 0;
    }

    public isAssessmentEnabled(uid:string) {
        if (this._environment.disabledAssessments.length == 0) {
            return true;
        }
        else {
            return this._environment.disabledAssessments.indexOf(uid) < 0;
        }
    }

    public get copyrightURL() {
        return this._environment.copyrightURL;
    }

    public get copyrightTitle() {
        return this._environment.copyrightTitle;
    }

    public get seamlessMode() {
        return this._seamlessMode;
    }

    public set seamlessMode(v:boolean) {
        this._seamlessMode = v;
        
    }
    
    public get ssoIssuer() {
        return this._ssoIssuer;
    }

    public set ssoIssuer(v:string) {
        this._ssoIssuer = v;
    }

    public setupSSOIssuerForSession(issuer:string) {
        this._ssoIssuer = issuer;
        sessionStorage.setItem("ssoIssuer", issuer);
    }
    public setupSeamlessModeForSession(skin?:string) {
        this.seamlessMode = true;
        sessionStorage.setItem('seamlessMode', "true");
        let skins = ['seamless'];
        if (skin) {
            skins.push(skin);
            
        }
        this.replaceSkinClasses(skins);
    }

    public get awsCognitoConfig() {
        return this._cognitoConfig;
    }
};


// WEBPACK FOOTER //
// ./src/app/shared/services/dac-config.service.ts